'use strict';

var GridSettingsManipulationExampleDirective = function GridSettingsManipulationExampleDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-settings-manipulation-example.html'),
    controller: 'GridSettingsManipulationExampleController',
    scope: {
      data: '='
    }
  };
};
GridSettingsManipulationExampleDirective.$inject = [];
module.exports = GridSettingsManipulationExampleDirective;